import { CssBaseline } from '@mui/material'
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles'
import {  ThemeProviderProps } from '@mui/material/styles/ThemeProvider'
import { FC, useMemo } from 'react'
import palette from './palette'
import typography from './typography'
import components from './components'
import './types'



const ThemeProvider: FC<Omit<ThemeProviderProps, 'theme'>> = ({ children }) => {
  const themeOptions = useMemo(
    () => ({
      typography,
      palette,
      components
    }),
    [],
  )

  const theme = createTheme(themeOptions)

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  )
}

export default ThemeProvider
